/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfSignificantEvents } from '../../models/data-page-of-significant-events';

export interface PatientGetSignificantList$Params {emrpracticeId?: string | null; PatientId?: string | null;  pageNumber?: number;  sortbydirection?: string | null;  searchText?: string | null;}

export function patientGetSignificantList(http: HttpClient, rootUrl: string, params?: PatientGetSignificantList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfSignificantEvents>> {
  const rb = new RequestBuilder(rootUrl, patientGetSignificantList.PATH, 'get');
  if (params) {
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('PatientId', params.PatientId, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('sortbydirection', params.sortbydirection, {});
    rb.query('searchText', params.searchText, {});
  }
  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfSignificantEvents>;
    })
  );
}

patientGetSignificantList.PATH = '/patient/significantevents';
